// Standalone navigation actions for Turbo Stream

export function redirect() {
  Turbo.visit(this.target)
}

export function update_url() {
  if (this.target) {
    Turbo.navigator.history.replace(new URL(this.target, window.location.origin))
  }
}
